import { yupResolver } from '@hookform/resolvers/yup';
import { ChevronLeftIcon, EnterIcon } from '@radix-ui/react-icons';
import { Button, Card, Flex, Spinner } from '@radix-ui/themes';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { PhaseType } from '../../../types/ScientificModule';
import { routes } from '../../../routes';
import TextFieldComponent from '../../../components/inputs/Textfield/TextfieldComponent';
import { createPhase, updatePhase } from '../../../services/scientific/phase';
import { CreatePhaseFormValidation } from './CreatePhaseFormValidation';
import { useGetPhasesQuery } from '../../../hooks/scientific/useGetPhasesQuery';
import SelectComponent from '../../../components/inputs/Select/SelectComponent';
import RadioGroupComponent from '../../../components/inputs/RadioGroup/RadioGroupComponent';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { useAppDispatch } from '../../../hooks/hooks';
import { resetPhasesData } from '../../../redux/slices/scientific/phases';

export const UpdatePhase = () => {
    const navigate = useNavigate();
    const mutation = useMutation({ mutationFn: updatePhase, mutationKey: 'updatePhase' });
    const phaseFormData = useSelector((state: RootState) => state.phases);
    const dispatch = useAppDispatch();

    const defaultValues: PhaseType = phaseFormData;

    const { control, handleSubmit, formState: { errors }, getValues } = useForm<PhaseType>({
        resolver: yupResolver(CreatePhaseFormValidation),
        defaultValues,
        mode: 'onBlur',
        reValidateMode: 'onBlur',
        shouldUseNativeValidation: false,
    });
    const { data: phases, isLoading, isError, refetch } = useGetPhasesQuery({ PageNumber: 1, PageSize: 400, IdProjectType: getValues('idProjectType') },
        {
            enabled: !!getValues('idProjectType')
        });


    const onSubmit = handleSubmit(async (data) => {
        try {
            const result = await mutation.mutateAsync(data);
            if (result) {
                toast.success("Fase atualizada!");
                navigate(routes.phases);
            }
        } catch (err: any) {
            toast.error(`${mutation.error ?? err?.message}`);
        }
    });

    const handleBack = () => {
        dispatch(resetPhasesData());
        navigate(routes.phases);
    }

    return (
        <form onSubmit={onSubmit} noValidate>
            <Card size='1'>
                <Flex direction='column' gap='4'>
                    <TextFieldComponent name="description" label="Descrição" control={control} errors={errors} fieldProps={{ placeholder: 'Descrição' }} required={true}/>
                    <SelectComponent
                        name="idPhasePrevious"
                        label="Fase Anterior"
                        control={control}
                        errors={errors}
                        options={phases?.items.filter(i=> i.idProjectType===getValues('idProjectType')).map((phase) => ({
                            value: phase.id ?? "",
                            label: phase.description ?? "",
                        }))}
                    />
                    <SelectComponent
                        name="idPhaseNext"
                        label="Fase Seguinte"
                        control={control}
                        errors={errors}
                        options={phases?.items.filter(i=> i.idProjectType===getValues('idProjectType')).map((phase) => ({
                            value: phase.id ?? "",
                            label: phase.description ?? "",
                        }))}
                    />
                    <Flex direction='column' gap='4'>
                        <RadioGroupComponent
                            name="start"
                            label="Início ?"
                            control={control}
                            errors={errors}
                            options={[
                                { value: "true", label: "Sim" },
                                { value: "false", label: "Não" }
                            ]}
                            style={{ display: 'flex', flexDirection: 'row', gap: 'var(--space-4)' }}
                        />
                        <RadioGroupComponent
                            name="end"
                            label="Fim ?"
                            control={control}
                            errors={errors}
                            options={[
                                { value: "true", label: "Sim" },
                                { value: "false", label: "Não" }
                            ]}
                            style={{ display: 'flex', flexDirection: 'row', gap: 'var(--space-4)' }}
                        />
                    </Flex>

                    <Flex direction='row' gap='3' justify='end'>
                        <Button type="button" variant='soft' color='gray' onClick={handleBack} disabled={mutation.isLoading}>
                            <ChevronLeftIcon /> Voltar
                        </Button>
                        <Button type="submit" disabled={mutation.isLoading}>
                            {mutation.isLoading ? <Spinner /> : <EnterIcon />}
                            Atualizar
                        </Button>
                    </Flex>
                </Flex>
            </Card>
        </form>
    );
};
